module.exports = __webpack_public_path__ + "youtube.svg?a6372485318244c18a497ae9a9b62467";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social/youtube.svg
// module id = 34
// module chunks = 0